import type { FaireProductEntity } from "../../entity_types/product";

export const p_7tarmfr6ze: FaireProductEntity = {
  token: "p_7tarmfr6ze",
  type: "product",
  name: "Linen-Feel Cocktail Napkins, Mahjong Assorted",
  brandToken: "b_gc7m3wmt3x",
  brandName: "Maven Home",
  imageUrl:
    "https://cdn.faire.com/fastly/092a7b99e2b46a67186ea6a9f9d43a7ed74980d0e5dc73d343e5f89a8eba9260.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/70197b8e45bcbdf7b890d67cb476de22a3c08f25395fbdcea27bea346fa24f6e.png",
    "https://cdn.faire.com/fastly/72eaf83ee68962f0ff8bc57e66671519a7008aae8ea8a52c9eff262449821a06.png",
    "https://cdn.faire.com/fastly/8c6d737339e73a4533e984813480db7e2b3e74418c7c9cfe1e09c77af5802f37.png",
    "https://cdn.faire.com/fastly/297f55ef7d24f6cebc3404c1129afcc00f0bd7231f8aba7341c73fdc62d41120.png",
    "https://cdn.faire.com/fastly/9798573007105fe056ca9dedfafab856a3a540a0cab109d5acf05955161ad4df.png",
  ],
  priceDollars: 5,
  description:
    'Add a touch of effortless sophistication to every occasion with our Linen-Feel Premium Cocktail Napkins. Crafted from thick, high-quality paper with a linen-like texture, they deliver the softness of fine fabric with the convenience of a disposable napkin.\r\n\r\n20 napkins per pack\r\nEach pack contains all 4 sayings - 5 of each\r\nPerfect for cocktail hours, bar carts, dinner parties, and holiday entertaining, these napkins elevate any tabletop with subtle luxury and practical polish. Durable, absorbent, and beautifully textured, they’re ideal for hostess gifts, event planners, and gift boutiques seeking elegant entertaining essentials.\r\n\r\nPair with our acrylic napkin holders for a complete modern-tabletop presentation.\r\n\r\nProduct Details\r\n20 cocktail napkins per pack\r\nSize: 5" × 5" folded\r\nMaterial: Premium linen-feel paper\r\nDisposable yet luxurious for easy entertaining\r\nNapkin holder sold separately',
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:42.166Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
